<ng-template #dropdownButtonTemplate>
  <ng-container *ngIf="isActive; else defaultButtonText">
    {{ appliedFilter.min.text }} - {{ appliedFilter.max.text }} m<sup>2</sup>
    {{ 'filters.propertySpace.label' | i18n }}
  </ng-container>
  <ng-template #defaultButtonText>
    {{ 'filters.propertySpace.label' | i18n }}
  </ng-template>
</ng-template>

<ng-template #dropdownContentTemplate>
  <lib-property-space-filter
    (update)="select($event)"
  ></lib-property-space-filter>
</ng-template>

<ng-template #applyButtonTemplate let-close="close">
  <button class="filter-apply-button" (click)="applyChanges(); close()">
    {{ 'common.apply' | i18n }}
  </button>
</ng-template>

<app-filter-dropdown
  [preferredWidth]="271"
  [dropdownButtonTemplate]="dropdownButtonTemplate"
  [dropdownContentTemplate]="dropdownContentTemplate"
  [applyButtonTemplate]="applyButtonTemplate"
  [hasValue]="isActive"
  (clear)="reset()"
>
</app-filter-dropdown>
